<template>
  <div class="btn" :class="classes" :data-color="color" @mousedown="doRipple($event)">
	  <slot></slot>
    <div class="ripple" :style="rippleStyle()"></div>
  </div>
</template>


<script>

export default {
  props: {
    color: String,
    disabled: { type:Boolean, default:false },
    full: { type:Boolean, default:false },
    block: { type:Boolean, default:false },
  },
  data(){
    return {
      ripple: {
          top: 0,
          left: 0,
          size: 150,
          active: false,
      }
    }
  },
  computed:{
    classes(){
      var output = ''
      if( this._props.disabled == true ) output += 'disabled '
      if( this._props.full == true ) output += 'block '
      if( this._props.block == true ) output += 'block '
      if( this._props.color ) output += 'btn-'+this._props.color
      if( this.ripple.active ) output += ' rippling '
      return output
    },
  },
  methods: {

    doRipple(e){
      if( this.ripple.active ) return
      this.ripple.top = e.offsetY
      this.ripple.left = e.offsetX
      this.ripple.active = true
      var _this = this
      setTimeout(function(){
        _this.ripple.active = false
      }, 400)
    },

    rippleStyle() {
        return {
            height: this.ripple.size + 'px',
            width: this.ripple.size + 'px',
            top: this.ripple.top + 'px',
            left: this.ripple.left + 'px',
            marginLeft: - (this.ripple.size/2) + 'px',
            marginTop: - (this.ripple.size/2) + 'px',
        };
    },

  },
}
</script>



// WEBPACK FOOTER //
// src/components/Btn.vue